import React from 'react';
import { Connected, IConnectedList } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { goBack, push } from 'connected-react-router';
import { connect } from 'react-redux';
import { useLocalErrorHandler } from 'hooks';

const ConnectedAscContainer = ({
    getAscs, ascsList, apiError, setErrorHandler,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetchAc = async () => {
            setProcessing(true);
            await getAscs({});
            setProcessing(false);
        };

        fetchAc();
    }, []);

    return null;
    // return (
    //     <Connected
    //       getList={getAscs}
    //       apiError={apiError}
    //       ascsList={ascsList as IConnectedList}
    //       cardCategory="Список АПК, с которыми вы сотрудничаете"
    //       showLoader={processing}
    //       withBorder
    //       onlyWatch
    //     />
    // );
};

const mapState = (state: IRootState) => ({
    ascsList: state.expert.acList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    onGoBack: () => dispatch(goBack()),
    getAscs: dispatch.expert.getAttestationCommissionsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ConnectedAscContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;
